export default __webpack_public_path__ + "static/media/notebook.71bb176f.svg";